var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li data-scroll-uid=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userId") : depth0), depth0))
    + "_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"articleNo") : depth0), depth0))
    + "\"> \n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"imageUrl") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + "    <div class=\"cont_common\">\n        <a href=\"/@"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"articleNo") : depth0), depth0))
    + "\" class=\"link_feed #post\">\n            <strong class=\"tit_subject\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "\n            </strong>\n            <span class=\"desc_common\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"subTitle") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":16},"end":{"line":14,"column":132}}})) != null ? stack1 : "")
    + "<span>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"contentSummary") : depth0), depth0))
    + "</span>\n            </span>\n        </a>\n        <div class=\"append_common\">\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"magazineAddress") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":18,"column":141}}})) != null ? stack1 : "")
    + "\n            <span class=\"ico_by\">by</span>\n            <a href=\"/@"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "\" class=\"link_bloger #writers\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"userName") : depth0), depth0))
    + "</a>\n            <span class=\"ico_dot\"></span>\n            <span class=\"txt_time\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"brunchDate") : depth0), depth0))
    + "</span>\n        </div>\n    </div>\n</li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <a href=\"/@"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"profileId") : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"articleNo") : depth0), depth0))
    + "\" class=\"link_thumb #post\">\n        <img src=\""
    + alias2(__default(require("../static/modernJs/handlebarsHelpers/thumbnail.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"imageUrl") : depth0),"C120x120",{"name":"thumbnail","hash":{},"data":data,"loc":{"start":{"line":5,"column":18},"end":{"line":5,"column":56}}}))
    + "\" width=\"120\" height=\"120\" class=\"img_thumb\" alt=\"\">\n    </a>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <em class=\"tit_sub\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"subTitle") : depth0), depth0))
    + "</em>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contentSummary") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":62},"end":{"line":14,"column":125}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "<span class=\"ico_bar\"></span>";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"magazineAddress") : depth0), depth0))
    + "\" class=\"link_category #magazine\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"magazineTitle") : depth0), depth0))
    + "</a> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"list") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "");
},"useData":true});